import React, { useEffect, useRef, useState } from 'react';
// import { MapContainer, Popup, Marker, TileLayer, useMapEvents } from 'react-leaflet';
// import makeAnimated from 'react-select/animated';
import { child, getDatabase, push, ref, onValue, get, remove } from "firebase/database";
// import Leaflet from "./LeafLet"
// import JobSelector from "./JobSelector.js"
// import { auth } from "./FireBase"
// import { createUserWithEmailAndPassword } from 'firebase/auth';
import Select from 'react-select';
// import { getAllByAltText } from '@testing-library/react';

const db = getDatabase()

const DeleteQR = () => {
    const sendDataRef = useRef(null)
    const [coffeeExist, setCoffeeExist] = useState(false)

    const valueChanged = (value) => {
        const dbRefLocation = child(ref(db), `locations/` + `${value.value}` + "/coffee_sets");
        get(dbRefLocation).then((snapshot) => {
            if (snapshot.exists()) {
                setCoffeeExist(true)
                console.log(snapshot.val())
                setCoffeeSets(Object.entries(snapshot.val()))

            }
            else {
                console.log("snapshot not exist")
                setCoffeeSets()
                setCoffeeExist(false)
            }
        });
        setSelectedLocations(value.value)
        console.log(value.value)
    }
    const cupsValueChanged = (value) => {
        setSelectedCups(value.value)
    }
    const [padding, setPadding] = useState(false)
    const [errorModal, setErrorModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [options, setOptions] = useState([])
    const [CupsOptions, setCupsOptions] = useState([])


    const [selectedLocations, setSelectedLocations] = useState(null)
    const [selectedCups, setSelectedCups] = useState(null)
    const [selectedCurrency, setSelectedCurrency] = useState(null)
    const [locations, setLocations] = useState(null)
    const [coffeeSets, setCoffeeSets] = useState(null)
    const [TechUid, setTechUid] = useState(sessionStorage.getItem("TechUid"))
    const [currencyOptions, setCurrencyOptions] = useState([]);





    window.onkeydown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault()
            sendDataRef?.current.click()
        }
    }


    const dbRefLocations = child(ref(db), `locations/`);
    useEffect(() => {
        onValue(dbRefLocations, (snapshot) => {
            if (snapshot.exists()) {
                setLocations(Object.entries(snapshot.val()))
            }
        })
    }, [])

    useEffect(() => {
        //console.warn(locations)
        let options = []
        locations?.forEach((location) => {
            options.push({ "value": location[1].location_id, "label": location[1].location_name })
        })
        setOptions(options)
    }, [locations])

    useEffect(() => {
        console.log()
        if (coffeeSets) {
            let CupsSelectOptions = [{ "value": "All", "label": "All Cups" }]
            coffeeSets?.forEach((CupsOption) => {
                CupsSelectOptions.push({ "value": CupsOption[0], "label": CupsOption[0] })
            })
            setCupsOptions(CupsSelectOptions)
        }
        else
            setCupsOptions([{ "value": "", "label": "No Cups Available" }])
    }, [coffeeSets])

    const deleteData = () => {
        console.log(selectedLocations + " - " + selectedCups)
        if (selectedCups == "All") {
            const dbRefCoffeeSets = child(ref(db), `locations/` + `${selectedLocations}` + "/coffee_sets/");
            setPadding(true)
            remove(dbRefCoffeeSets).then((res) => {
                console.log(res)
                setSuccessModal(true)
            }).catch((error) => {
                setErrorModal(true)
                console.error(error)
            });
        }
        else {
            const dbRefCoffeeSets = child(ref(db), `locations/` + `${selectedLocations}` + "/coffee_sets/" + selectedCups);
            setPadding(true)
            remove(dbRefCoffeeSets).then((res) => {
                console.log(res)
                setSuccessModal(true)
            }).catch((error) => {
                setErrorModal(true)
                console.error(error)
            });
        }
    }

    return (
        <div id='addDevices'>
            <div id="myModal" className={errorModal ? "modal fade show" : "modal fade"}>
                <div className="modal-dialog modal-confirm">
                    <div className="modal-content">
                        <div className="modal-header justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="m330 768 150-150 150 150 42-42-150-150 150-150-42-42-150 150-150-150-42 42 150 150-150 150 42 42Zm150 208q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Zm0-60q142 0 241-99.5T820 576q0-142-99-241t-241-99q-141 0-240.5 99T140 576q0 141 99.5 240.5T480 916Zm0-340Z" /></svg>
                            <button type="button" className="close" onClick={() => setErrorModal(false)} data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body text-center">
                            <h4>Ooops!</h4>
                            <p>Something went wrong.</p>
                            <button className="btn btn-success" onClick={deleteData} data-dismiss="modal">Try Again</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className={successModal ? "modal success fade show" : "modal success fade"}>
                <div className="modal-dialog modal-confirm">
                    <div className="modal-content">
                        <div className="modal-header justify-content-center">
                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z" /></svg>
                            <button type="button" className="close" onClick={() => window.location.reload()} data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body text-center">
                            <h4>Great!</h4>
                            <p>Coffee sets removed successfully.</p>
                            <button className="btn btn-success" onClick={() => window.location.reload()} data-dismiss="modal">Ok</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="label--input">
                <label>Select Location</label>
                <Select id='job-selector' options={options} onChange={valueChanged} />
                <p style={coffeeExist ? { display: "none" } : { display: "block", color: "red" }}>No coffee sets exist at this location!</p>
            </div>
            <div className="label--input">
                <label>Select Cups</label>
                <Select id='job-selector' options={CupsOptions} onChange={cupsValueChanged} />
            </div>
            <button ref={sendDataRef} disabled={coffeeExist ? false : true} className={padding ? 'sendDataButton deleteQrButton padding' : 'sendDataButton deleteQrButton'} onClick={deleteData}>Delete All QR's</button>
        </div>
    )
}

export default DeleteQR;